import {Adsense} from '@ctrl/react-adsense';
import React, { useEffect, useState } from "react";

const Ad = ({width, height, format, slot}) => {
   const [showAd, setShowAd] = useState(false);
   const delay = 5000;
  useEffect(() => {
    const timer = setTimeout(() => setShowAd(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return (
        <div className="adunit"> 
        {showAd && (           
        <Adsense
        client="ca-pub-2706630587106567"
        slot={slot}
        style={{ width: {width}, height: {height}, display: 'block' }}
        layout="in-article"
        format={format}
        responsive='true'
        />    
        )}     
        </div>
       
    );
}

export default Ad; 